import { render, staticRenderFns } from "./EditCreditLimit.vue?vue&type=template&id=7479a723&"
import script from "./EditCreditLimit.vue?vue&type=script&lang=js&"
export * from "./EditCreditLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports